<template>
  <div class="container">
    <el-carousel
      height="520px"
      :interval="5000"
      arrow="always"
      trigger="click"
    >
      <el-carousel-item
        v-for="item in bannerList"
        :key="item.id"
      >
        <img class="banner-img" :src="item.img" alt="banner" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: 'HomeBanner',
  props: {
    bannerList: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.container >>> .el-carousel__button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #fff;
  opacity: .48;
}

.container >>> .is-active .el-carousel__button {
  opacity: 1;
}

.container >>> .el-carousel__arrow {
  width: 40px;
  height: 40px;
  font-size: 30px;
}

.banner-img {
  height: 520px;
  width: 100%;
}

</style>
